import RemotePath from '../../../consts/RemotePaths';

/**
 * Dados da clínica e do profissional usados nos cabeçalhos dos relatórios em
 * PDF (plano alimentar, medidas, mapas, fotos), lidos do CompanyConfig.
 */

/** Props do `Header` do documento a partir do CompanyConfig. */
export function companyHeaderProps(company) {
  const data = company || {};
  const logo = data.Logo && data.Id !== undefined
    ? RemotePath.PATH_USER_UPLOADS_COMPANY_LOGO(data.Id) + data.Logo
    : '';
  const address = [
    [data.Address, data.Number, data.Complement].filter(Boolean).join(', '),
    [data.District, data.City && data.State ? `${data.City} - ${data.State}` : data.City || data.State, data.Cep].filter(Boolean).join(', '),
  ].filter(Boolean).join('\n');

  return { logo, title: data.Name || '', address, CNPJ: data.CNPJ || '', phone: data.Phone || '' };
}

/** Pega o recurso (profissional) da clínica pelo id do agendamento. */
export function findProfessional(companyConfig, professionalId) {
  const resources = companyConfig?.Resources;
  if (!professionalId || !Array.isArray(resources)) return null;
  return resources.find((item) => String(item.Id ?? item.id) === String(professionalId)) || null;
}

/** Linhas de identificação do profissional para o `PersonInfos`. */
export function professionalInfos(professional) {
  if (!professional) return [];
  return [
    { key: 'Profissional:', value: professional.Label || '' },
    ...(professional.Regulator ? [{ key: 'Registro:', value: professional.Regulator }] : []),
  ];
}
